import { Button, Input, Typography } from 'antd'
import type { JSX } from 'react'
import { Field, Form } from 'react-final-form'

import { RoleFields } from './RoleFields'

import { Client, PendingInvite, Role } from 'api/clients'
import { StyledModal } from 'shared/components/Modal'
import { getPrimaryRole, toInviteRoles } from 'utils/roles'

export type PendingInviteEditModalProps = {
  invite: PendingInvite
  allRoles: Role[]
  primaryRoles: Role[]
  isDownloadEnabled: boolean
  client: Client
  onSubmit(roles: Role[]): any
  onCancel(): any
}

export function PendingInviteEditModal({
  invite,
  allRoles,
  primaryRoles,
  isDownloadEnabled,
  client,
  onSubmit,
  onCancel,
}: PendingInviteEditModalProps): JSX.Element {
  return (
    <Form<{ roles: Role[] }>
      initialValues={{ roles: toInviteRoles(invite, allRoles) }}
      onSubmit={({ roles: selectedRoles }) => onSubmit(selectedRoles)}
      render={({ handleSubmit, values, submitting }) => (
        <StyledModal
          cancelText={null}
          confirmLoading={submitting}
          footer={
            <Button
              data-testid="pending-invite-save-button"
              disabled={!getPrimaryRole(values.roles)}
              key="submit"
              loading={submitting}
              onClick={handleSubmit}
              size="large"
              type="primary"
            >
              Save
            </Button>
          }
          onCancel={onCancel}
          open={true}
          title="Edit Invite"
        >
          <form onSubmit={handleSubmit}>
            <label htmlFor="email">Email Address</label>
            <Input disabled id="email" size="large" type="email" value={invite.email} />
            <Field<Role[]> name="roles">
              {({ input }) => (
                <RoleFields
                  allRoles={allRoles}
                  client={client}
                  isDownloadEnabled={isDownloadEnabled}
                  onChange={input.onChange}
                  primaryRoles={primaryRoles}
                  selectedRoles={input.value}
                />
              )}
            </Field>
            <Typography.Text type="secondary">This invite has not been accepted yet.</Typography.Text>
          </form>
        </StyledModal>
      )}
    />
  )
}
